import { render } from "./LiElementClient.vue?vue&type=template&id=108f999a"
import script from "./LiElementClient.vue?vue&type=script&lang=js"
export * from "./LiElementClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__